import { render, staticRenderFns } from "./GrabberStep.vue?vue&type=template&id=52857511"
import script from "./GrabberStep.vue?vue&type=script&lang=js"
export * from "./GrabberStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports